export const historyStack: string[] = [];

// 뒤로가기 실행중 세팅 및 확인
let isBackNavigation = false;
export function startBackNavigation() {
  isBackNavigation = true;
}
export function endBackNavigation() {
  isBackNavigation = false;
}
export function getIsBackNavigation() {
  return isBackNavigation;
}

// 페이지 정보 삽입
export function pushHistory(state: string) {
  
    const last = historyStack[historyStack.length - 1];
    if (state === "just back" || last !== state) {
        historyStack.push(state);
        window.dispatchEvent(new Event("historyStackChange"));

// console.log("** [PUSH]: ", historyStack);
    }
}

// 뒤로가기 페이지 추출
export function popHistory(): string | undefined {
  historyStack.pop(); 
  window.dispatchEvent(new Event("historyStackChange"));
// console.log("** [POP]: ", historyStack, historyStack.length,  historyStack[historyStack.length - 1])
  return historyStack[historyStack.length - 1]; 
}
// 현재페이지 추출
export function getHistory(): string | undefined {
  // window.dispatchEvent(new Event("historyStackChange"));
// console.log("** [GET]: ", historyStack[historyStack.length - 1])
  return historyStack[historyStack.length - 1]; 
}

// 싹없애
export function clearHistory() {
  historyStack.length = 0;
}


// 강제 리다이렉트 페이지면 삽입한 기본페이지 정보 삭제
let needRefresh = false;
export function setNeedRefresh(value: boolean) {
  needRefresh = value;
}
export function getNeedRefresh() {
  return needRefresh;
}
export function replaceHistory(state: string) {
    if(!getNeedRefresh()) return;
    setNeedRefresh(false)
    if (historyStack.length > 1) {
        historyStack.splice(historyStack.length - 2, 1);
    }
    if (historyStack.length > 0) {
        historyStack[historyStack.length - 1] = state;
    } else {
        historyStack.push(state);
    }
// console.log("** [REPLACE]: ", historyStack);
}


// 버튼 비활성화 세팅할때 쓸거야
export function isBackDisabled(): boolean {
// console.log("** [DISABLED]:", historyStack.length===0 || historyStack[0] === "/");

    
      const _prevtmp1 = historyStack[0]?.split("/")[1];
      const _prevtmp2 = _prevtmp1?.split("?")[0];


    return historyStack.length === 0 || (historyStack.length ===1 && (historyStack[0] === "/" || _prevtmp2 === "") );
}